import React, { useState, useEffect } from "react";
import { X, Gift, ArrowRight } from "lucide-react";
import { Button } from "./ui/button";

const FreeQuoteBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="fixed left-0 right-0 z-40 transition-all duration-300" style={{ top: "80px" }}>
      <div className="bg-gradient-to-r from-emerald-500 via-emerald-600 to-green-600 text-white py-2 px-4 shadow-lg">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center space-x-3 flex-1">
            <Gift className="hidden md:block animate-bounce" size={24} />
            <div className="flex-1">
              <p className="text-sm md:text-base font-bold">
                🎁 OFFRE LIMITÉE : Conseil Gratuit + Devis Personnalisé en 24h !
              </p>
              <p className="text-xs md:text-sm opacity-90 hidden sm:block">
                Profitez de notre expertise pour économiser jusqu'à 5 000€ par an
              </p>
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <Button
              onClick={() => document.getElementById('estimation').scrollIntoView({ behavior: 'smooth' })}
              className="bg-white text-emerald-600 hover:bg-gray-100 font-bold text-sm md:text-base py-2 px-4 md:px-6 rounded-lg border-0 whitespace-nowrap"
            >
              J'en profite
              <ArrowRight className="ml-2" size={18} />
            </Button>
            <button
              onClick={() => setIsVisible(false)}
              className="hover:bg-emerald-700 rounded p-1 transition-colors"
              aria-label="Fermer"
            >
              <X size={18} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FreeQuoteBanner;